export const questionTypes=['Short text','Long text','Number','Date','Time','Yes / No','Single select','Multiple select','Dropdown','Song entry','Playlist URL','File upload','Repeating fields','Custom text block'];

const question=(id,title,type='Short text',options=[],required=false)=>({
  id,
  title,
  type,
  options,
  required,
  visible:true,
  help:'',
  placeholder:''
});

const eventTimingQuestions=[
  question('eventDuration','Event Duration'),
  question('eventStartTime','Event Start Time','Time'),
  question('setupStartTime','Setup Start Time','Time'),
  question('eventEndTime','Event End Time','Time')
];

const venueRequirements=[
  'Wireless microphone',
  'Ceremony sound system',
  'Reception sound system',
  'Dance floor',
  'Stage',
  'Power access',
  'Lighting restrictions',
  'Candles permitted',
  'Confetti permitted',
  'Fog or haze permitted',
  'Outdoor noise restrictions',
  'Load-in instructions',
  'Parking or vendor access',
  'Certificate of insurance required',
  'Venue contact confirmation',
  'Other venue requirements'
];

export const weddingSections=[
  {
    id:'welcome',
    title:'Welcome',
    description:'Your celebration begins here.',
    enabled:true,
    questions:[
      question('couple','Bride and groom names'),
      question('vision','How would you describe your ideal celebration?','Long text')
    ]
  },
  {
    id:'event',
    title:'Event Information',
    description:'Review the details imported from your booking.',
    enabled:true,
    questions:[
      question('date','Wedding date','Date',[],true),
      question('guests','Number of guests','Number'),
      ...eventTimingQuestions.map((item)=>({...item})),
      question('ceremonyTime','Ceremony start time','Time',[],true),
      question('receptionTime','Reception start time','Time'),
      question('services','Services booked','Multiple select',[
        'DJ',
        'MC',
        'Photo Booth',
        'Lighting',
        'LED screens',
        'Projector',
        'Karaoke',
        'Temporary Tattoos'
      ])
    ]
  },
  {
    id:'venue',
    title:'Venue',
    description:'Ceremony,reception and production locations.',
    enabled:true,
    questions:[
      question('ceremonyFacility','Ceremony facility'),
      question('ceremonyAddress','Ceremony address'),
      question('receptionFacility','Reception facility'),
      question('receptionAddress','Reception address'),
      question('venueRequirements','Venue Requirements Checklist','Multiple select',venueRequirements),
      question('differentRoom','Is cocktail hour in a different room?','Yes / No'),
      question('roomDetails','Cocktail room,music location and start time','Long text')
    ]
  },
  {
    id:'timeline',
    title:'Timeline',
    description:'Build the run of show for your event.',
    enabled:true,
    questions:[]
  },
  {
    id:'ceremony',
    title:'Ceremony Music',
    description:'Plan the music for your ceremony and key reception moments.',
    enabled:true,
    questions:[
      question('seatingSong','Seating music','Song entry'),
      question('partyEntranceSong','Bridal party / family entrance song','Song entry'),
      question('groomEntranceSong','Groom entrance song','Song entry'),
      question('brideEntranceSong','Bride entrance song','Song entry'),
      question('ceremonyEndSong','Ceremony ending / breaking-the-glass song','Song entry'),
      question('entranceOrder','Ceremony Entrance Order and Pronunciations','Long text')
    ]
  },
  {
    id:'music',
    title:'Music & Playlists',
    description:'Shape the soundtrack for every moment.',
    enabled:true,
    questions:[
      question('songRequests','Can the DJ take Song requests?','Yes / No'),
      question('grandEntranceSong','Grand Entrance Song','Song entry'),
      question('cakeSong','Cake Cutting Song','Song entry'),
      question('bouquetTossSong','Bouquet Toss Song','Song entry'),
      question('knifeDanceSong','Knife Dance Song','Song entry'),
      question('lastSong','Last song','Song entry'),
      question('cocktailGenres','Cocktail hour music','Multiple select',[
        'Big Band',
        'Soft Rock',
        'Alternative',
        'Motown',
        'Current Top 40',
        'Israeli/Jewish',
        'Smooth Jazz',
        'Country',
        'Deep / Afro House',
        'Instrumental piano/violin covers'
      ]),
      question('dinnerGenres','Dinner music','Multiple select',[
        'Big Band',
        'Soft Rock',
        'Alternative',
        'Motown',
        'Current Top 40',
        'Israeli/Jewish',
        'Smooth Jazz',
        'Country',
        'Latin-style guitar covers',
        'Instrumental piano/violin covers'
      ]),
      question('danceGenres','Dancing music','Multiple select',[
        'Motown',
        'Rock',
        'Top 40 / Pop',
        'Reggaeton',
        'Hip-Hop',
        'Oldies',
        '70s',
        '80s',
        'Disco',
        'Country',
        'Israeli/Jewish',
        'Techno',
        'EDM / House',
        'Latin',
        '90s-2000s'
      ])
    ]
  },
  {
    id:'special',
    title:'Special Events',
    description:'Dances,traditions and meaningful moments.',
    enabled:true,
    questions:[
      question('firstDance','First dance song','Song entry'),
      question('parentDances','Parent dances and songs','Repeating fields'),
      question('additionalDances','Will there be additional dances?','Yes / No'),
      question('additionalDanceDetails','Describe additional dances and songs','Long text'),
      question('ceremonies','Special ceremonies','Multiple select',[
        'Garter removal',
        'Garter toss',
        'Bouquet toss',
        'Winner’s ceremony',
        'Custom ceremony'
      ])
    ]
  },
  {
    id:'announcements',
    title:'Announcements',
    description:'Toasts,acknowledgments and logistics.',
    enabled:true,
    questions:[
      question('requests','Should the DJ announce guest song requests?','Yes / No'),
      question('toasts','Toast and blessing speakers','Long text'),
      question('announcements','Announcements and dedications','Long text'),
      question('vendors','Banquet manager,photographer and videographer','Long text')
    ]
  },
  {
    id:'notes',
    title:'Final Notes',
    description:'Anything else that will help the event flow smoothly.',
    enabled:true,
    questions:[
      question('finalNotes','Additional event information','Long text')
    ]
  },
  {
    id:'review',
    title:'Review & Submit',
    description:'Review your planner before sending it to our team.',
    enabled:true,
    questions:[]
  }
];

export const mitzvahSections=[
  weddingSections[0],
  {
    ...weddingSections[1],
    questions:[
      question('honoree','Bar/Bat Mitzvah name','Short text',[],true),
      question('date','Event Date','Date',[],true),
      question('guests','Number of guests','Number'),
      question('eventDuration','Event Duration'),
      question('eventStartTime','Event Start Time','Time'),
      question('setupStartTime','Setup Start Time','Time'),
      question('eventEndTime','Event End Time','Time'),
      question('start','Event Start Time','Time'),
      question('setup','Setup start time','Time'),
      question('end','Event end time','Time'),
      question('services','Services booked','Multiple select',[
        'DJ',
        'MC',
        'Dancers',
        'Photo Booth',
        'Lighting',
        'LED screens',
        'Projector'
      ])
    ]
  },
  {
    ...weddingSections[2],
    questions:[
      question('venueName','Venue name'),
      question('venueAddress','Venue address'),
      question('contact','Venue contact person and phone'),
      question('room','Primary room,floor and indoor/outdoor'),
      question('guests','Number of guests','Number'),
      question('children','Number of children','Number'),
      question('theme','Party theme and colors'),
      question('vendors','Other vendors,phone numbers and Instagram handles','Long text')
    ]
  },
  weddingSections[3],
  {
    id:'reception',
    title:'Reception',
    description:'Entrances,candle lighting and traditions.',
    enabled:true,
    questions:[
      question('introductions','Introduction order,names,wording and music','Repeating fields'),
      question('kiddush','Kiddush?','Yes / No'),
      question('kiddushSpeaker','Kiddush speaker and pronunciation'),
      question('hamotzi','HaMotzi?','Yes / No'),
      question('hora','Traditional Hora?','Yes / No'),
      question('chairLift','Chair lifting and who will be lifted','Long text')
    ]
  },
  {
    ...weddingSections[5],
    questions:[
      question('musicStyles','Cocktail,dinner and reception music','Multiple select',[
        'Current Pop',
        'Deep House',
        'Classic Jazz',
        'Classic Rock',
        'Hebrew',
        'Jewish',
        'Orthodox'
      ]),
      question('cultural','Ethnic and cultural music','Multiple select',[
        'Israeli',
        'Jewish',
        'Orthodox',
        'Moroccan',
        'Persian/Iranian',
        'French',
        'Russian',
        'Spanish',
        'Tripoli',
        'Yemen',
        'Arabic',
        'Greek',
        'Iraqi',
        'Armenian'
      ]),
      question('lineDances','Line Dances','Multiple select',[
        'Cha Cha Slide',
        'Cupid Shuffle',
        'Macarena',
        'YMCA',
        'Wobble',
        'Crank That',
        'Whip Nae Whip',
        'Electric Slide',
        'Jerusalema',
        'Other'
      ]),
      question('songRequests','Can the DJ take Song requests?','Yes / No'),
      question('cocktailGenres','Cocktail Hour Music','Multiple select',[
        'Big Band',
        'Soft Rock',
        'Alternative',
        'Motown',
        'Current Top 40',
        'Israeli/Jewish',
        'Smooth Jazz',
        'Country',
        'Deep / Afro House',
        'Instrumental piano/violin covers'
      ]),
      question('dinnerGenres','Dinner Music','Multiple select',[
        'Big Band',
        'Soft Rock',
        'Alternative',
        'Motown',
        'Current Top 40',
        'Israeli/Jewish',
        'Smooth Jazz',
        'Country',
        'Latin-style guitar covers',
        'Instrumental piano/violin covers'
      ])
    ]
  },
  {
    ...weddingSections[6],
    questions:[
      question('hostDance','Host/Hostess dance song and when guests should join','Long text'),
      question('parentDance','Guest of Honor / Parent dance','Long text'),
      question('games','Would you like games or contests?','Single select',[
        'Specific time',
        'Throughout the event',
        'No games'
      ]),
      question('finale','Grand finale and last dance song','Long text')
    ]
  },
  weddingSections[7],
  weddingSections[8],
  weddingSections[9]
];

export const initialTimeline=[
  {
    id:1,
    time:'5:00 PM',
    name:'Ceremony',
    music:'Guest seating',
    notes:''
  },
  {
    id:2,
    time:'6:00 PM',
    name:'Cocktail Hour',
    music:'Curated playlist',
    notes:''
  },
  {
    id:3,
    time:'7:00 PM',
    name:'Grand Entrance',
    music:'TBD',
    notes:''
  },
  {
    id:4,
    time:'7:30 PM',
    name:'Dinner Service',
    music:'Dinner playlist',
    notes:''
  },
  {
    id:5,
    time:'8:30 PM',
    name:'Open Dancing',
    music:'Dance set',
    notes:''
  }
];

export const initialEvents=[
  {
    id:1,
    name:'Sarah & David',
    client:'Sarah Cohen',
    email:'sarah@example.com',
    type:'Wedding',
    date:'Jun 20,2027',
    venue:'Bel-Air Bay Club',
    guests:175,
    dj:'Asi Vidal',
    services:['DJ','MC','Photo Booth','Uplighting'],
    completion:68,
    updated:'Today,10:42 AM',
    status:'In Progress'
  },
  {
    id:2,
    name:'Ethan’s Bar Mitzvah',
    client:'Rachel Stein',
    email:'rachel@example.com',
    type:'Bar/Bat Mitzvah',
    date:'Sep 12,2027',
    venue:'Skirball Cultural Center',
    guests:220,
    dj:'Asi Vidal',
    services:['DJ','MC','Dancers','LED screens'],
    completion:92,
    updated:'Yesterday,4:18 PM',
    status:'Under Review'
  },
  {
    id:3,
    name:'Maya & Jordan',
    client:'Maya Lewis',
    email:'maya@example.com',
    type:'Wedding',
    date:'Oct 3,2027',
    venue:'The Ebell of Los Angeles',
    guests:140,
    dj:'TBD',
    services:['DJ','Lighting'],
    completion:24,
    updated:'Sep 8,2:15 PM',
    status:'In Progress'
  }
];